<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
export default {
    props: {
        params: {
            type: Object,
            default: () => {}
        },
        // check: 审核台详情
        type: String
    },
    data() {
        return {
            info: {
                checkInfos: []
            },
            activeName: 'works',
            contracts: [],
            examineState: {"0": "待审核", "1": "审核通过", "-1": "已驳回", "-2": "已失效或撤回", "-3": "已回退"},
            examines: {
                0: '视觉审核' ,
                1: '价格确认' ,
                2: '价格审批'
            }
        };
    },
    methods: {
        init() {
            this.getContractList()
            if(this.type === 'check') {
                this.photoworkReviewInfo()
            }else {
                this.getPhotoworkDetail()
            }
        },
        async getPhotoworkDetail() {
            let { type } = this.params
            let apiName = 'getPhotoworkDetail'

            if(type === 9) {
                apiName = 'getContributionDetail'
            }

            let data = await this.api[apiName](this.params)

            let { thumbPicUrl, previewPic } = data
            let pics = []

            if(thumbPicUrl) {
                pics = [thumbPicUrl]
            }else {
                pics = previewPic.split(',')
            }
            data.pics = pics
            this.info = data
        },
        async getContractList() {
            let { type } = this.params
            let apiName = 'getPhotoworkContractList'

            if(type === 9) {
                apiName = 'getContributionworkContractList'
            }

            let data = await this.api[apiName](Object.assign({ type: 8 }, this.params))

            this.contracts = data
        },
        async photoworkReviewInfo() {
            let data = await this.api.photoworkReviewInfo(Object.assign({ type: 8 }, this.params))

            let { thumbPicUrl, previewPic } = data
            let pics = []

            if(thumbPicUrl) {
                pics = [thumbPicUrl]
            }else {
                pics = previewPic.split(',')
            }
            data.pics = pics
            this.info = data
        }
    },
    computed: {
        examineItem() {
            let type = this.params.type
            let name = '摄影投稿'

            if(type === 9) {
                name = '作品投稿'
            }

            return name
        },
        step() {
            let type = this.params.type
            let step = {
                0: '视觉审核' ,
                1: '价格确认' ,
                2: '价格审批'
            }

            if(type === 9) {
                step = {
                    0: '视觉审核',
                    1: '稿件检查',
                    2: '价格确认',
                    3: '价格审批',
                }
            }

            return step
        }
    },
    created() {
        this.init()
    },
    activated() {
        this.init()
    },
};
</script>
